import { defineMessages } from 'react-intl';

export const messages: {
	defaultPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	searchHint: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	searchHintDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	defaultPlaceholder: {
		id: 'company-hub.article-search-component.placeholder',
		defaultMessage: 'Search for help',
		description: 'Default placeholder text for the article search input.',
	},
	searchHint: {
		id: 'company-hub.article-search-component.search-hint',
		defaultMessage: 'Search',
		description:
			'Label shown next to an Enter key icon at the end of the search field, hinting that pressing Enter runs the search.',
	},
	searchHintDescription: {
		id: 'company-hub.article-search-component.search-hint-description',
		defaultMessage: 'Press Enter to search',
		description:
			'Description of the search field, announced to screen reader users only, explaining that pressing the Enter key runs the search.',
	},
});
